import React from "react";

export const ForwardIcon = () => {
  return (
    <svg
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{ marginLeft: 10 }}
    >
      <path d="M8 7L3.27273 0.5H0L4.72727 7L0 13.5H3.27273L8 7Z" fill="white" />
    </svg>
  );
};

export default React.memo(ForwardIcon);
